export default __webpack_public_path__ + "static/media/steam-library-unlock.de45bb73.png";